/**
 * ChatFileChips — Pre-send file preview chips row.
 *
 * Shows attached file chips inside the input box (above textarea).
 * Each chip has a remove button. Additional files shown as "+N" badge.
 */

import React from "react";
import { X, Paperclip } from "lucide-react";

const ChatFileChips = ({
  messageFiles,
  allowFiles,
  onFileDelete,
  onAttachmentsOpen,
  secondaryColor,
}) => {
  if (!messageFiles || messageFiles.length === 0) return null;

  return (
    <div className="flex items-center gap-1.5 flex-wrap px-3.5 pt-2">
      {messageFiles.map((file, idx) => (
        <span
          key={idx}
          className="inline-flex items-center gap-1.5 py-1 pl-2.5 pr-1.5 text-xs border rounded-lg bg-gray-100 text-gray-500 max-w-[200px]"
          style={{ borderColor: secondaryColor || "#e5e7eb" }}
        >
          <Paperclip size={13} className="text-gray-400 shrink-0" />
          <span className="truncate">{file.name}</span>
          <button
            type="button"
            onClick={() => onFileDelete?.(idx)}
            className="flex items-center justify-center w-3.5 h-3.5 rounded-[4px] hover:bg-gray-300 transition-colors cursor-pointer border-none bg-transparent text-gray-400 hover:text-gray-900"
            aria-label={`Remove ${file.name}`}
          >
            <X size={10} />
          </button>
        </span>
      ))}
    </div>
  );
};

export { ChatFileChips };
export default ChatFileChips;
